var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkl-daterange" },
    [
      _c(
        "DatePicker",
        _vm._b(
          {
            ref: "startDatePicker",
            attrs: { calendarButtonIcon: "fa fa-calendar" },
            on: { changedDay: _vm.selectedStartDay },
            model: {
              value: _vm.startDay,
              callback: function ($$v) {
                _vm.startDay = $$v
              },
              expression: "startDay",
            },
          },
          "DatePicker",
          _vm.startDayAttrs,
          false
        )
      ),
      _vm._v(" "),
      _vm._t("midContentSlot"),
      _vm._v(" "),
      _c(
        "DatePicker",
        _vm._b(
          {
            ref: "endDatePicker",
            attrs: { calendarButtonIcon: "fa fa-calendar" },
            on: { changedDay: _vm.selectedEndDay },
            model: {
              value: _vm.endDay,
              callback: function ($$v) {
                _vm.endDay = $$v
              },
              expression: "endDay",
            },
          },
          "DatePicker",
          _vm.endDayAttrs,
          false
        )
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }